export default "__VITE_ASSET__2dbd1c4a__"